module.exports = __webpack_public_path__ + "img/topsOn.c794ca6f.svg";